import { Component, OnInit } from '@angular/core';
import { DataProviderService } from '../../service/data-provider.service';


@Component({
  selector: 'app-update',
  templateUrl: './update.component.html',
  styleUrls: ['./update.component.css']
})
export class UpdateComponent implements OnInit {

  News: any;
  constructor(private datapro: DataProviderService) {
    this.News = this.datapro.newSinglesample
    // console.log(this.datapro.son)
  }


  ngOnInit() {
  }

}